module.exports = __webpack_public_path__ + "static/media/image-gallery-1.3674548e.jpg";